import { render, staticRenderFns } from "./EdTable.vue?vue&type=template&id=5bb57b0b&scoped=true&"
import script from "./EdTable.vue?vue&type=script&lang=js&"
export * from "./EdTable.vue?vue&type=script&lang=js&"
import style0 from "./EdTable.vue?vue&type=style&index=0&id=5bb57b0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb57b0b",
  null
  
)

export default component.exports